<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.oms }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.order_list }}
      </v-card-title>
    </v-card>

    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="22" color="success darken-3">mdi-clipboard-list-outline</v-icon><span class="ml-3">{{ use_language.order_list }}</span>
        <v-spacer/>
        <!-- ผู้อนุมัติ: อนุมัติหลายรายการพร้อมกันได้ในแท็บที่รอการอนุมัติของตน -->
        <v-btn v-if="isPendingTab" :elevation="1" color="success" class="px-2 mr-2" :disabled="selected.length == 0" @click="confirmApprove(selected)">
          <v-icon size="20" class="mr-1">mdi-check-circle-outline</v-icon>
          {{ use_language.approve_selected }} ({{ selected.length }})
        </v-btn>
        <v-btn v-if="canCreate" :elevation="1" color="primary" class="px-2" to="/oms/add-order">
          <v-icon size="22" class="mr-1">mdi-plus</v-icon>
          {{ use_language.add_order }}
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col v-if="locations.length > 1" cols="12" md="3" class="pa-1">
            <v-autocomplete v-model="filter.locationId" :items="locationItems" :label="use_language.location" outlined dense hide-details @change="search()"></v-autocomplete>
          </v-col>
          <v-col cols="6" md="2" class="pa-1">
            <v-text-field v-model="filter.dateFrom" type="date" :label="use_language.date_from" outlined dense hide-details @change="search()"></v-text-field>
          </v-col>
          <v-col cols="6" md="2" class="pa-1">
            <v-text-field v-model="filter.dateTo" type="date" :label="use_language.date_to" outlined dense hide-details @change="search()"></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="filter.keyword"
              :placeholder="use_language.search + ' ' + use_language.request_no + ' / ' + use_language.store_name"
              prepend-inner-icon="mdi-magnify"
              autocomplete="off"
              outlined
              dense
              hide-details
              clearable
              @keyup.enter="search()"
              @click:clear="filter.keyword = null; search()"
            ></v-text-field>
          </v-col>
          <!-- Sale เห็นเฉพาะคำสั่งซื้อของตัวเองอยู่แล้ว (backend บังคับ) ช่อง "เฉพาะของฉัน" จึงมีเฉพาะ Admin ซึ่งสร้างคำสั่งซื้อเองได้ด้วย -->
          <v-col v-if="isAdmin" cols="12" md="2" class="pa-1 d-flex align-center">
            <v-checkbox v-model="filter.onlyMine" :label="use_language.only_mine" hide-details class="mt-0" @change="search()"></v-checkbox>
          </v-col>
          <!-- ค้นหาตาม Sale ผู้สร้าง: Admin เห็น Sale ทุกคน ส่วน Manager เห็นเฉพาะ Sale ในเขตของตน -->
          <v-col v-if="canApprove" cols="12" md="3" class="pa-1">
            <v-autocomplete
              v-model="filter.createdByStaffId"
              :items="creatorItems"
              :label="use_language.role_CREATOR"
              outlined
              dense
              hide-details
              @change="search()"
            ></v-autocomplete>
          </v-col>
          <v-col v-if="canApprove" cols="12" md="2" class="pa-1">
            <v-select v-model="filter.myAction" :items="myActionItems" :label="use_language.my_action" outlined dense hide-details @change="search()"></v-select>
          </v-col>
        </v-row>

        <oms-reject-dialog
          v-model="rejectDialog"
          :temp-id="rejectTarget.tempID"
          :request-no="rejectTarget.requestNo"
          @done="Load_data()"
        />

        <v-tabs v-model="tab" show-arrows class="mt-2" @change="search()">
          <v-tab v-for="status in statusTabs" :key="status">
            {{ tabLabel(status) }} ({{ formatMoney(String(counts[countField[status]] || 0)) }})
          </v-tab>
        </v-tabs>

        <!-- PC hidden-xs-only -->
        <v-data-table
          v-model="selected"
          :headers="header"
          :items="items"
          item-key="tempID"
          :show-select="isPendingTab"
          :items-per-page="take"
          hide-default-footer
          :no-data-text="use_language.no_data"
          class="packhai-border-table hidden-xs-only mt-3"
        >
          <template v-slot:item.requestNo="{ item }"><a @click="openDetail(item)">{{ orderNo(item) }}</a></template>
          <template v-slot:item.action="{ item }">
            <a class="mr-3" @click="confirmApprove([item])"><v-icon size="20" color="success">mdi-check-circle-outline</v-icon></a>
            <a @click="openReject(item)"><v-icon size="20" color="red">mdi-close-circle-outline</v-icon></a>
          </template>
          <template v-slot:item.submittedAt="{ item }">{{ formatOmsDatetime(item.submittedAt) }}</template>
          <template v-slot:item.locationName="{ item }">{{ item.locationName }}</template>
          <template v-slot:item.storeName="{ item }">
            <div>{{ item.storeName }}</div>
            <div style="font-size: 12px; color: #9e9e9e;">{{ item.storeCode }}</div>
            <div v-if="item.status == 'REJECTED' && item.lastRejectReason" style="font-size: 12px; color: red;">{{ use_language.reject_reason }} : {{ item.lastRejectReason }}</div>
          </template>
          <template v-slot:item.totalQuantity="{ item }">{{ formatMoney(String(item.itemCount)) }} / {{ formatMoney(String(item.totalQuantity)) }}</template>
          <template v-slot:item.status="{ item }">
            <v-chip small dark :color="statusColor[item.status]">{{ use_language[statusLabelKey(item)] }}</v-chip>
          </template>
        </v-data-table>

        <!-- Mobile hidden-sm-and-up -->
        <v-data-iterator
          :items="items"
          :items-per-page="take"
          hide-default-footer
          :no-data-text="use_language.no_data"
          class="hidden-sm-and-up mt-3"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.tempID" cols="12" class="pa-1">
                <v-card @click="openDetail(item)">
                  <v-row class="pa-2">
                    <v-col cols="7" class="pa-0"><b>{{ orderNo(item) }}</b></v-col>
                    <v-col cols="5" class="pa-0 text-right">
                      <v-chip x-small dark :color="statusColor[item.status]">{{ use_language[statusLabelKey(item)] }}</v-chip>
                    </v-col>
                    <v-col cols="12" class="pa-0">{{ item.storeName }}</v-col>
                    <v-col cols="12" class="pa-0" style="font-size: 12px; color: #9e9e9e;">{{ item.locationName }} · {{ formatOmsDatetime(item.submittedAt) }} · {{ item.createdByName }}</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.items_and_pieces }} : {{ item.itemCount }} / {{ formatMoney(String(item.totalQuantity)) }}</v-col>
                    <v-col v-if="item.status == 'REJECTED' && item.lastRejectReason" cols="12" class="pa-0" style="color: red;">{{ use_language.reject_reason }} : {{ item.lastRejectReason }}</v-col>
                    <v-col v-if="isPendingTab" cols="12" class="pa-0 pt-2 text-right">
                      <v-btn small color="success" class="mr-2" @click.stop="confirmApprove([item])">{{ use_language.action_APPROVE }}</v-btn>
                      <v-btn small color="red" dark @click.stop="openReject(item)">{{ use_language.action_REJECT }}</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>

        <div class="pt-3">
          <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7" @input="Load_data()"></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Swal from 'sweetalert2'
  import Loading from '@/website/components/Loading'
  import OmsRejectDialog from '@/website/backend/oms/components/OmsRejectDialog'
  import { formatMoney } from '@/website/global_function'
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { OMS_STATUS_TABS, OMS_STATUS_COLOR, OMS_STATUS_COUNT_FIELD, formatOmsDatetime, orderNo, statusLabelKey } from '@/website/backend/oms/oms_status'
  import { getOmsContext, getOrderRequestList, getOrderRequestCount, getCreatorList, approveOrderRequest } from '@/website/backend/oms/oms_service'

  export default {
    components: {
      Loading,
      OmsRejectDialog
    },
    data: () => ({
      // page
      page_loading: true,
      loading: false,
      use_language: getOmsLanguage(),
      statusTabs: OMS_STATUS_TABS,
      statusColor: OMS_STATUS_COLOR,
      countField: OMS_STATUS_COUNT_FIELD,

      canCreate: false,
      isAdmin: false,
      // Sale ช่องทาง TT: ออเดอร์เข้าระบบทันทีโดยไม่ผ่านการอนุมัติ จึงไม่มีแท็บที่เกี่ยวกับการอนุมัติ
      isDirectSale: false,
      // สถานะที่รอการอนุมัติของผู้ใช้คนนี้: Manager = รอผู้จัดการ, Admin = รอ Admin, Sale = ไม่มี
      pendingStatus: null,
      locations: [],
      creators: [],
      filter: { locationId: null, keyword: null, dateFrom: null, dateTo: null, onlyMine: false, myAction: null, createdByStaffId: 0 },
      tab: 0,
      counts: {},
      items: [],
      selected: [],
      rejectDialog: false,
      rejectTarget: { tempID: 0, requestNo: '' },
      count: 0,
      page: 1,
      take: 20
    }),
    computed: {
      pageCount () {
        return Math.ceil(this.count / this.take)
      },
      canApprove () {
        return this.pendingStatus != null
      },
      // แท็บที่ผู้ใช้คนนี้อนุมัติได้: แสดงช่องเลือกและปุ่มอนุมัติ/ไม่อนุมัติ
      isPendingTab () {
        return this.canApprove && this.statusTabs[this.tab] == this.pendingStatus
      },
      creatorItems () {
        // ค่า 0 = ทั้งหมด (ใช้ 0 แทน null เพื่อให้ช่องแสดงคำว่า "ทั้งหมด" เป็นตัวเลือกที่ถูกเลือกอยู่)
        return [
          { value: 0, text: this.use_language.all },
          ...this.creators.map(item => ({ value: item.staffShopID, text: item.name + ' (' + item.username + ')' }))
        ]
      },
      myActionItems () {
        return [
          { value: null, text: this.use_language.all },
          { value: 'APPROVE', text: this.use_language.approved_by_me },
          { value: 'REJECT', text: this.use_language.rejected_by_me }
        ]
      },
      locationItems () {
        return [
          { value: null, text: this.use_language.all_location },
          ...this.locations.map(location => ({ value: location.id, text: location.channel + ' : ' + location.name }))
        ]
      },
      header () {
        return [
          { text: this.use_language.request_no, align: 'center', value: 'requestNo', sortable: false, width: '130px' },
          { text: this.use_language.submitted_at, align: 'center', value: 'submittedAt', sortable: false, width: '140px' },
          { text: this.use_language.location, align: 'left', value: 'locationName', sortable: false, width: '190px' },
          { text: this.use_language.store, align: 'left', value: 'storeName', sortable: false },
          { text: this.use_language.items_and_pieces, align: 'center', value: 'totalQuantity', sortable: false, width: '130px' },
          { text: this.use_language.created_by, align: 'left', value: 'createdByName', sortable: false, width: '150px' },
          { text: this.use_language.status, align: 'center', value: 'status', sortable: false, width: '150px' },
          { text: this.use_language.approval, align: 'center', value: 'action', sortable: false, width: '110px', pendingOnly: true }
        ].filter(column => this.isPendingTab || !column.pendingOnly)
      }
    },
    async created () {
      document.title = this.$router.history.current.meta.title
      const context = await getOmsContext()
      this.locations = context.locations || []
      this.canCreate = context.role == 'ADMIN' || context.role == 'CREATOR'
      this.isAdmin = context.role == 'ADMIN'
      this.isDirectSale = context.role == 'CREATOR' && context.channel == 'TT'
      if (this.isDirectSale) {
        this.statusTabs = ['APPROVED', 'CANCELLED']
      }
      this.pendingStatus = context.role == 'ADMIN' ? 'WAIT_ADMIN' : (context.role == 'APPROVER' ? 'WAIT_MANAGER' : null)
      // กลับมาจากหน้ารายละเอียด: เปิดแท็บเดิม ไม่อย่างนั้นผู้อนุมัติเริ่มที่แท็บที่รอตัวเองอนุมัติ
      const status = this.$route.query.status
      if (status != null && this.statusTabs.indexOf(status) >= 0) {
        this.tab = this.statusTabs.indexOf(status)
      } else if (this.pendingStatus != null) {
        this.tab = this.statusTabs.indexOf(this.pendingStatus)
      }
      if (this.pendingStatus != null) {
        // รายชื่อ Sale สำหรับตัวกรอง backend คืนเฉพาะคนที่ผู้ใช้นี้มีสิทธิ์เห็น
        const creators = await getCreatorList()
        this.creators = creators.status == 'success' ? creators.items : []
      }
      await this.Load_data()
      this.page_loading = false
    },
    methods: {
      formatMoney,
      formatOmsDatetime,
      orderNo,
      statusLabelKey,
      tabLabel (status) {
        if (this.isDirectSale && status == 'APPROVED') {
          return this.use_language.tab_order
        }
        return this.use_language['status_' + status]
      },
      filterBody () {
        return {
          locationId: this.filter.locationId,
          keyword: this.filter.keyword,
          dateFrom: this.filter.dateFrom || null,
          dateTo: this.filter.dateTo || null,
          onlyMine: this.filter.onlyMine,
          myAction: this.filter.myAction,
          createdByStaffId: this.filter.createdByStaffId || null
        }
      },
      async search () {
        this.page = 1
        await this.Load_data()
      },
      async Load_data () {
        this.loading = true
        this.selected = []
        const body = this.filterBody()
        const [list, counts] = await Promise.all([
          getOrderRequestList({ ...body, statuses: [this.statusTabs[this.tab]], skip: (this.page - 1) * this.take, take: this.take }),
          getOrderRequestCount(body)
        ])
        this.loading = false
        if (list.status != 'success') {
          this.$swal({
            position: 'top',
            type: 'error',
            text: list.message || (list.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
          })
          return
        }
        this.items = list.items
        this.count = list.searchResultCount
        if (counts.status == 'success') {
          this.counts = counts
        }
      },
      openDetail (item) {
        this.$router.push('/oms/order-detail?id=' + item.tempID)
      },
      openReject (item) {
        this.rejectTarget = { tempID: item.tempID, requestNo: orderNo(item) }
        this.rejectDialog = true
      },
      confirmApprove (items) {
        Swal.fire({
          type: 'question',
          title: this.use_language.action_APPROVE + ' ' + items.length + ' ' + this.use_language.items,
          text: this.pendingStatus == 'WAIT_ADMIN' ? this.use_language.confirm_approve_admin : this.use_language.confirm_approve_manager,
          confirmButtonText: this.use_language.action_APPROVE,
          cancelButtonText: this.use_language.close,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.value) {
            this.loading = true
            const response = await approveOrderRequest(items.map(item => item.tempID))
            this.loading = false
            if (response.status != 'success') {
              this.$swal({
                position: 'top',
                type: 'error',
                text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
              })
              return
            }
            // บางรายการอาจไม่ผ่าน เช่น ถูกคนอื่นทำไปก่อน หรือ stock จริงไม่พอ จึงรายงานรายคำขอ
            const failed = response.results.filter(item => item.status != 'success')
            await this.Load_data()
            if (failed.length == 0) {
              this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
            } else {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: this.use_language.approve_result + ' ' + (response.results.length - failed.length) + ' / ' + response.results.length,
                html: failed.map(item => '<div style="text-align:left;">' + (item.requestNo || '#' + item.tempID) + ' : ' + item.message + '</div>').join('')
              })
            }
          }
        })
      }
    }
  }
</script>
